<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M3.2 11C3.8 11 4.2 11.4 4.2 12 4.2 16.3 7.7 19.8 12 19.8 13.9 19.8 15.7 19.1 17.1 17.9 17.5 17.6 18.1 17.6 18.5 18 18.8 18.5 18.8 19.1 18.4 19.5 16.7 20.9 14.4 21.8 12 21.8 6.6 21.8 2.2 17.4 2.2 12 2.2 11.4 2.6 11 3.2 11Z"/><path d="M12 4.2C10.1 4.2 8.3 4.9 6.9 6.1 6.5 6.4 5.9 6.4 5.5 6 5.2 5.5 5.2 4.9 5.6 4.5 7.3 3.1 9.6 2.2 12 2.2 17.4 2.2 21.8 6.6 21.8 12 21.8 12.6 21.4 13 20.8 13 20.2 13 19.8 12.6 19.8 12 19.8 7.7 16.3 4.2 12 4.2Z"/><path d="M20.8 16L17.6 11.2H24L20.8 16Z"/><path d="M3.2 8L6.4 12.8H0L3.2 8Z"/></svg>
</template>

<script>
export default {
  name: 'RefreshIcon'
}
</script>
